export default ngModule => {

  ngModule.factory('AonApi', function (AonConfig, $http) {

    class AonApi {

      post(endpoint, data) {
        const postData = _.extend({'corporate_id': AonConfig.corporate.id}, data);
        return $http.post('/api/' + endpoint, postData);
      }

      get(endpoint, data = {}) {
        const params = _.extend({'corporate_id': AonConfig.corporate.id}, data);
        return $http.get('/api/'+endpoint, {
          params: params
        });
      }

      fetchPrice(applicant, priceId) {
        const allowedZohoKeys = ["corporate_flow_type", "corporate_code", "channel", "rebate_percent"];

        const zohoData = _.get(applicant, "zoho", {}); // Parse if stored as a JSON string

        const filteredZoho = Object.fromEntries(
            Object.entries(zohoData).filter(([key]) => allowedZohoKeys.includes(key))
        );

        const params = {
          primary_dob: _.get(applicant, 'personal.dob'),
          partner_dob: _.get(applicant, 'partner.dob'),
          primary_lhc_age: _.get(applicant, 'policy.lhc_age'),
          partner_lhc_age: _.get(applicant, 'policy.lhc_age_partner'),
          primary_youth_discount_age: _.get(applicant, 'policy.primary_youth_discount_age'),
          partner_youth_discount_age: _.get(applicant, 'policy.partner_youth_discount_age'),
          has_primary_previous_fund: _.get(applicant, 'personal.previous_fund.has_previous_fund'),
          zoho: filteredZoho, // Assign only filtered keys
        };

        if (_.get(applicant, 'policy.federal_rebate')) {
          params.rebate_tier = _.get(applicant, 'policy.rebate_tier');
        }

        if (_.get(applicant, 'zoho.rebate_percent')) {
          params.rebate_percent = _.get(applicant, 'zoho.rebate_percent');
        }

        if (_.get(applicant, 'policy.discount_code')) {
          params.discount_code = _.get(applicant, 'policy.discount_code');
        }

        return this.get(`prices/${priceId}/`, params);
      }

    }

    return new AonApi();

  });


};



// WEBPACK FOOTER //
// ./src/services/api-service.js